import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Navbar from './components/layout/Navbar'

import Index from './components/layout/Index'
import About from './components/layout/About'
import Footer from './components/layout/Footer'
// import NewDetail from './components/news/NewDetail'
import {Provider} from './context'
import './App.css';

function App() {
  return (
    <Provider>
      <Router>
      <React.Fragment>
        <Navbar />
         <div className="container">
          <Switch>
            <Route exact path="/" component={Index}/>
            <Route exact path="/about" component={About}/>
            {/* <Route exact path="/news/new/:id" component={NewDetail}/>  */}
          </Switch>
        </div>
        <Footer/>
      </React.Fragment>
    </Router>
    </Provider>   
  );
}

export default App;
